import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Form, Tooltip } from 'antd';
import { useRenderReusableControls, getDefaultTimes, getCustomEndDateValidation } from 'helper/reusableControls';
import { useUserTimeFormat } from 'helper/commonHooks';
import { FORM_RULES } from '../../../constants';
import './ruleSettingsPage.less';
import { isMobile } from 'utils/detectDevice';

interface AutonomousDefaultControlProps {
  prefix?: string;
  startLabel?: string;
  endLabel?: string;
  showDefaultDates?: boolean;
  sTime?: object;
  eTime?: object;
  onChange?: any;
}

const AutonomousDefaultControls: React.FC<AutonomousDefaultControlProps> = ({
  prefix, startLabel, endLabel, showDefaultDates, sTime, eTime, onChange
}) => {
  const { t } = useTranslation();
  const userTimeFormat = useUserTimeFormat();
  const now = moment();
  const endDate = moment(now).add(2, 'hours');
  const { renderDatePicker } = useRenderReusableControls(t);
  const { startTime, endTime } = getDefaultTimes(undefined, undefined, sTime, eTime);
  const { requiredCustomEndDateValidation } = getCustomEndDateValidation(prefix, t);
  const rules = FORM_RULES(t);
  const { requiredField, requiredEndDateValidation } = rules;

  return (
    <>
      <div className="flex-space-between margin-15">
        <Form.Item
          name={`${prefix}starting_time_window`}
          label={<Tooltip title={t(startLabel || 'Start Date')}>
            <span className={`ellipsis-label ${isMobile ? 'mobile-label' : ''}`}>
              {t(startLabel || 'Start Date')}
            </span>
          </Tooltip>}
          rules={requiredField}
          className="font-bold form-item-width-100"
        >
          {renderDatePicker(!showDefaultDates ? now : startTime, userTimeFormat.unitsTime, onChange)}
        </Form.Item>

        <Form.Item
          name={`${prefix}ending_time_window`}
          label={<Tooltip title={t(endLabel || 'End Date')}>
            <span className={`ellipsis-label ${isMobile ? 'mobile-label' : ''}`}>
              {t(endLabel || 'End Date')}
            </span>
        </Tooltip>}
          dependencies={[`${prefix}starting_time_window`]}
          rules={prefix?.length ? requiredCustomEndDateValidation : requiredEndDateValidation}
          className="font-bold form-item-width-100"
        >
          {renderDatePicker(!showDefaultDates ? endDate : endTime, userTimeFormat.unitsTime, onChange)}
        </Form.Item>
      </div>
    </>
  );
};

AutonomousDefaultControls.defaultProps = {
  prefix: '',
  startLabel: '',
  endLabel: '',
  showDefaultDates: false,
};

export default AutonomousDefaultControls;
